//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState /*useEffect, useContext*/ } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Popover } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';
import { INFO_TEXT_TRACK_EMP_HIRING_STATISTICS } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdBox from '../../common/elemental/AfitdBox';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            backgroundColor: '#FFFFFF',
        },
        infoIcon: { fontSize: 16, marginBottom: 0 },
        infoPopover: {
            padding: 10,
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        infoPopoverOpen,
        anchorEl,
        setAnchorEl,
    } = params;

    let defns = {
        infoIconButton: {
            size: 'small',
            onClick: evt => {
                setAnchorEl(evt.currentTarget);
            },
        },
        infoPopover: {
            open: infoPopoverOpen,
            anchorEl,
            onClose: () => {
                setAnchorEl(null);
            },
            anchorOrigin: {
                vertical: 'center',
                horizontal: 'center',
            },
        },
        infoContainer: {
            p: 1,
            minWidth: '30%',
            maxWidth: 300,
        },
        infoText: {
            variant: 'body2',
            value: INFO_TEXT_TRACK_EMP_HIRING_STATISTICS,
        },
    };
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const FieldLabelWithTrackStatInfo = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [anchorEl, setAnchorEl] = useState(null);
    const infoPopoverOpen = Boolean(anchorEl);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { children, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, infoPopoverOpen, anchorEl, setAnchorEl });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <AfitdBox {...defns.root}>
            <AfitdTypography variant="caption" {...otherProps}>
                {children}
            </AfitdTypography>
            <IconButton {...defns.infoIconButton}>
                <InfoIcon {...defns.infoIcon} />
            </IconButton>
            <Popover {...defns.infoPopover}>
                <AfitdBox {...defns.infoContainer}>
                    <AfitdTypography {...defns.infoText} />
                </AfitdBox>
            </Popover>
        </AfitdBox>
    );
};

export default FieldLabelWithTrackStatInfo;
